export function generateOrganizationPathParams(organization: string): { organization: { name: string } } {
  return { organization: { name: organization } };
}

export function generateProjectPathParams(
  organization: string,
  project: string,
): { organization: { name: string }; project: { name: string } } {
  return { organization: { name: organization }, project: { name: project } };
}

export function generateApplicationPathParams(
  organization: string,
  project: string,
  application: string,
): { organization: { name: string }; project: { name: string }; application: { name: string } } {
  return { organization: { name: organization }, project: { name: project }, application: { name: application } };
}
